import React from 'react';
import { ActionsColumn, DataTableMeta, Typography } from '@otp/ui';
import { TFunction } from 'i18next';
import { OTPsRestaurantsAssignedListActions } from './restaurants-assigned-list-actions';
import { getAddress } from 'src/utils/restaurant-data';
import { StoreModel, User } from 'src/graphql/generated/graphql';
import { Star } from '@otp/icons';

type DataParams = {
  user: Partial<User>;
  stores: Array<Partial<StoreModel & { isPrimary: boolean | null }>>;
  withoutActions: boolean;
};

export const getTableConfig = (
  { stores, user, withoutActions }: DataParams,
  { t }: { t: TFunction },
) => [
  {
    name: 'name',
    label: t('user-details.stores-assigned', 'Store assigned'),
    options: {
      sort: true,
      customBodyRender: (value: any, column: DataTableMeta) => {
        const rawData = stores[column.rowIndex];
        return (
          <div className="flex-col space-x-1">
            <p>{rawData.name}</p>
            <Typography variant="subtitle2">{getAddress(rawData)}</Typography>
          </div>
        );
      },
    },
  },
  {
    name: 'assigned',
    label: t('user-details.store-assigned', 'Assigned As'),
    options: {
      sort: false,
      customBodyRender: (value: any, column: DataTableMeta) => {
        const rawData = stores[column.rowIndex];
        return rawData.isPrimary ? (
          <div className="flex gap-1">
            <Typography variant="subtitle1" className="flex items-center">
              <Star />
              {t('user-details.primary', 'Primary')}
            </Typography>
          </div>
        ) : (
          <Typography variant="subtitle1">
            {t('user-details.secondary', 'Secondary')}
          </Typography>
        );
      },
    },
  },
  {
    name: 'nationalStoreNumber',
    label: t('user-details.store-id', 'Store ID'),
    options: {
      sort: false,
    },
  },
  ...(!withoutActions
    ? [
        {
          name: 'actions',
          label: t('user-details.store-actions', 'Actions'),
          options: {
            customBodyRender: (value: any, column: DataTableMeta) => {
              const rawData = stores[column.rowIndex];
              return (
                <OTPsRestaurantsAssignedListActions
                  store={rawData}
                  user={user}
                  storeHasPrimary={rawData.isPrimary || false}
                />
              );
            },
            sort: false,
          },
        },
      ]
    : []),
];
